module.exports = __webpack_public_path__ + "img/dgjg2335_1.b87e68e0.svg";